
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-39c50a89\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AnnouncementForm.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AnnouncementForm.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-39c50a89\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AnnouncementForm.vue"),
  /* scopeId */
  "data-v-39c50a89",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/Announcement/components/AnnouncementForm.vue
// module id = 2102
// module chunks = 1